import type { Ladezustand } from '../lib/laden'

export default function Ladehinweis({
  zustand,
}: {
  zustand: Ladezustand<unknown>
}) {
  if (zustand.art === 'laedt') {
    return (
      <div className="karte">
        <p className="gedaempft">Lädt …</p>
      </div>
    )
  }
  if (zustand.art === 'fehler') {
    return (
      <div className="karte">
        <p className="meldung meldung-fehler" role="alert">
          {zustand.meldung}
        </p>
      </div>
    )
  }
  return null
}
